import { actions } from '@app/store/action/contacts';

const initialState = {
  isLoaded: false,
  list: {},
};

export default function (state = initialState, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_CONTACTS_SUCCESS:
      return {
        ...state,
        list: action.list.reduce((cur, contact) => {
          const { id, email, name, company } = contact;
          cur[email] = { id, name, company };
          return cur;
        }, {}),
        isLoaded: true,
      };
    case actions.ADD_CONTACT_SUCCESS: {
      const { id, name, company } = action.contact;
      return {
        ...state,
        list: {
          ...state.list,
          [action.contact.email]: { id, name, company },
        },
      };
    }
    case actions.EDIT_CONTACT_SUCCESS: {
      const { id, name, email, company } = action.contact;

      state.list = Object.keys(state.list).reduce(
        (acc, email) => {
          if (state.list[email].id === id) {
            return acc;
          }
          acc[email] = state.list[email];
          return acc;
        },
        {
          [email]: { id, name, company },
        }
      );

      return state;
    }
    case actions.REMOVE_CONTACTS_SUCCESS: {
      const list = state.list;
      Object.keys(state.list).forEach((contact) => {
        if (action.ids.indexOf(list[contact].id) > -1) {
          delete list[contact];
        }
      });

      return {
        ...state,
        list,
      };
    }
  }

  return state;
}
